module.exports = __webpack_public_path__ + "img/menu-close.7c8dd510.svg";